































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'


import JobEmploymentPositionResourceItem1JobPositionDescription from './service-for-job-employment-position-resource-item/job-employment-position-resource-item-1-job-position-description.vue'
import JobEmploymentPositionResourceItem2JobPositionStatistics from './service-for-job-employment-position-resource-item/job-employment-position-resource-item-2-job-position-statistics.vue'


@Component({
  components: {
    JobEmploymentPositionResourceItem1JobPositionDescription,
    JobEmploymentPositionResourceItem2JobPositionStatistics
  }
})
class ProductResourceHelperComponents3ResourceList extends Vue {
  @Prop({ default: '' }) productResourceId?: string

  isExandedPanelList: number[] = []

  isOpenAccountDescription: number = 0
  isOpenAccountStatistics: number = 0
  isOpenTransactionStatistics: number = 0
}

export default ProductResourceHelperComponents3ResourceList

